const reason = [
  "Damaged",
  "Saleable",
  "Short Supply",
  "Near Expiry",
  "Wrong Dispatch",
  "Sale(Sample)",
  "Expired Returns",
  "Near Expiry(Sample)",
  "Product Complaint Price change",
  "Product Complaint Batch Recall",
  "Saleable Distributor error",
  "Saleable Field staff error",
  "Saleable New product returns",
  "Saleable Govt Notification",
  "Product Complaint Pack size change",
  "Product Complaint Discontinued product",
];

const saleable = [
  "Damaged",
  "Saleable",
  "Sale(Sample)",
  "Wrong Dispatch",
  "Product Complaint Batch Recall",
  "Saleable Distributor error",
  "Saleable Field staff error",
  "Saleable New product returns",
  "Saleable Govt Notification",
  "Product Complaint Pack size change",
  "Product Complaint Price change",
  "Product Complaint Discontinued product",
  "Short Supply",
];

const saleableOnlyReasons = saleable.filter((reason) => reason !== "Damaged");

const near_expiry = ["Damaged", "Near Expiry", "Near Expiry(Sample)"];

const COLD_STORAGE_2_8 = "CC(2-8 degree)";

const isCc28 = (coldStorage) => {
  if (!coldStorage) return false;
  const normalized = coldStorage.replace(/\s/g, "").toLowerCase();
  return (
    normalized === "cc(2-8degree)" ||
    normalized === "cc(2-8_degree)" ||
    normalized === "cc_2_8"
  );
};

const returnTypeFinder = (value, coldStorage = null) => {
  let options;
  switch (value) {
    case "Expired Returns":
      options = ["Expired Returns"];
      break;

    case "Saleable":
      options = saleable;
      break;

    case "Near Expiry":
      options = near_expiry;
      break;

    case "Damaged":
      options = ["Damaged"];
      break;

    default:
      options = [];
  }

  if (isCc28(coldStorage)) {
    return options.filter((option) => !saleableOnlyReasons.includes(option));
  }

  return options;
};

const isReturnTypeDisabled = (goodsType, coldStorage = null) => {
  if (goodsType === "Damaged") return true;
  if (isCc28(coldStorage) && goodsType === "Expired Returns") return true;
  return false;
};

export {
  saleable,
  near_expiry,
  reason,
  returnTypeFinder,
  COLD_STORAGE_2_8,
  isCc28,
  isReturnTypeDisabled,
};
